/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountantPouchAdminDto } from '../models/AccountantPouchAdminDto';
import type { DriverPouchAdminDto } from '../models/DriverPouchAdminDto';
import type { ExportAdminResponse } from '../models/ExportAdminResponse';
import type { GetCurrentUserAccountantPouchCheckResponseAdmin } from '../models/GetCurrentUserAccountantPouchCheckResponseAdmin';
import type { Pagination1OfAccountantPouchListedAdminDto } from '../models/Pagination1OfAccountantPouchListedAdminDto';
import type { Pagination1OfDriverPouchListedAdminDto } from '../models/Pagination1OfDriverPouchListedAdminDto';
import type { PouchDriverDto } from '../models/PouchDriverDto';
import type { PouchMaxLimitAmountRequestAdmin } from '../models/PouchMaxLimitAmountRequestAdmin';
import type { PouchOperationTypeFilterAdmin } from '../models/PouchOperationTypeFilterAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PouchesService {
    /**
     * @returns PouchDriverDto OK
     * @throws ApiError
     */
    public static getPouchByCurrentDriverDriver(): CancelablePromise<PouchDriverDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/pouches/driver/current',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverPouches`
     * @returns DriverPouchAdminDto OK
     * @throws ApiError
     */
    public static getDriverPouchByDriverAdmin({
        driverId,
    }: {
        driverId: number,
    }): CancelablePromise<DriverPouchAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/pouches/drivers/drivers/{driverId}',
            path: {
                'driverId': driverId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverPouches`
     * @returns DriverPouchAdminDto OK
     * @throws ApiError
     */
    public static getDriverPouchAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<DriverPouchAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/pouches/drivers/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverPouches`
     * @returns DriverPouchAdminDto OK
     * @throws ApiError
     */
    public static putDriverPouchMaxLimitAmountAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PouchMaxLimitAmountRequestAdmin,
    }): CancelablePromise<DriverPouchAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/pouches/drivers/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewAccountantPouches`
     * @returns AccountantPouchAdminDto OK
     * @throws ApiError
     */
    public static getAccountantPouchAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<AccountantPouchAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/pouches/accountant/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverPouches`
     * @returns Pagination1OfDriverPouchListedAdminDto OK
     * @throws ApiError
     */
    public static getDriverPouchesAdmin({
        driverId,
        driverHalted,
        isDriverBlocked,
        regionId,
        transactionsFromDate,
        transactionsToDate,
        pouchOperationsType,
        page,
        limit,
    }: {
        driverId?: number,
        driverHalted?: boolean,
        isDriverBlocked?: boolean,
        regionId?: number,
        transactionsFromDate?: string,
        transactionsToDate?: string,
        pouchOperationsType?: PouchOperationTypeFilterAdmin,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfDriverPouchListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/pouches/drivers',
            query: {
                'driverId': driverId,
                'driverHalted': driverHalted,
                'isDriverBlocked': isDriverBlocked,
                'regionId': regionId,
                'transactionsFromDate': transactionsFromDate,
                'transactionsToDate': transactionsToDate,
                'pouchOperationsType': pouchOperationsType,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewAccountantPouches`
     * @returns Pagination1OfAccountantPouchListedAdminDto OK
     * @throws ApiError
     */
    public static getAccountantPouchesAdmin({
        userId,
        transactionsToDate,
        transactionsFromDate,
        pouchOperationsType,
        page,
        limit,
    }: {
        userId?: string,
        transactionsToDate?: string,
        transactionsFromDate?: string,
        pouchOperationsType?: PouchOperationTypeFilterAdmin,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfAccountantPouchListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/pouches/accountants',
            query: {
                'userId': userId,
                'transactionsToDate': transactionsToDate,
                'transactionsFromDate': transactionsFromDate,
                'pouchOperationsType': pouchOperationsType,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetCurrentUserAccountantPouchCheckResponseAdmin OK
     * @throws ApiError
     */
    public static getCurrentUserAccountantPouchCheckAdmin(): CancelablePromise<GetCurrentUserAccountantPouchCheckResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/pouches/accountants/currenet',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ExportDriverPouchFiles`
     * @returns ExportAdminResponse OK
     * @throws ApiError
     */
    public static exportDriverPouchFilesAdmin({
        driverId,
        driverHalted,
        isDriverBlocked,
        regionId,
        transactionsFromDate,
        transactionsToDate,
        pouchOperationsType,
        page,
        limit,
    }: {
        driverId?: number,
        driverHalted?: boolean,
        isDriverBlocked?: boolean,
        regionId?: number,
        transactionsFromDate?: string,
        transactionsToDate?: string,
        pouchOperationsType?: PouchOperationTypeFilterAdmin,
        page?: number,
        limit?: number,
    }): CancelablePromise<ExportAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/pouches/drivers/export',
            query: {
                'driverId': driverId,
                'driverHalted': driverHalted,
                'isDriverBlocked': isDriverBlocked,
                'regionId': regionId,
                'transactionsFromDate': transactionsFromDate,
                'transactionsToDate': transactionsToDate,
                'pouchOperationsType': pouchOperationsType,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ExportAccountantPouchFiles`
     * @returns ExportAdminResponse OK
     * @throws ApiError
     */
    public static exportAccountantPouchFilesAdmin({
        userId,
        transactionsToDate,
        transactionsFromDate,
        pouchOperationsType,
        page,
        limit,
    }: {
        userId?: string,
        transactionsToDate?: string,
        transactionsFromDate?: string,
        pouchOperationsType?: PouchOperationTypeFilterAdmin,
        page?: number,
        limit?: number,
    }): CancelablePromise<ExportAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/pouches/accountants/export',
            query: {
                'userId': userId,
                'transactionsToDate': transactionsToDate,
                'transactionsFromDate': transactionsFromDate,
                'pouchOperationsType': pouchOperationsType,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
